<div ref="ViewContracts" class="border-card border-0 p-3 container-fluid px-3 px-md-4 py-3 py-md-4 ">
  <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-3 g-md-4 ">
    <!-- Total contracts Card -->
    <div class="col">
      <div class="card card-bg shadow rounded-lg border-0 h-100">
        <div class="card-body p-3">
          <div class="d-flex flex-column flex-sm-row justify-content-between h-100">
            <div class="mb-3 mb-sm-0">
              <p class="text-white mb-1 fs-6">Total Contracts</p>
              <p class="mb-0 text-primary-green fs-4">0</p>
            </div>
            <div class="text-center text-sm-end">
              <div class="p-1 p-md-2">
                <i class="fa-solid fa-file-invoice text-primary fa-lg mb-2 mb-md-3"></i>
              </div>
              <a href="#" class="d-block text-primary-green text-decoration-none fs-6 fs-md-5">
                View
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pending Forms Card -->
    <div class="col">
      <div class="card card-bg shadow rounded-lg border-0 h-100">
        <div class="card-body p-3">
          <div class="d-flex flex-column flex-sm-row justify-content-between h-100">
            <div class="mb-3 mb-sm-0">
              <p class="text-white mb-1 fs-6">Pending Signature</p>
              <p class="mb-0 text-primary-green fs-4">0</p>
            </div>
            <div class="text-center text-sm-end">
              <div class="p-1 p-md-2">
                <i class="fa-solid fa-file-circle-exclamation fa-lg text-primary-green mb-2 mb-md-3"></i>
              </div>
              <a href="#" class="d-block text-primary-green text-decoration-none fs-6 fs-md-5">
                View
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Approved Forms Card -->
    <div class="col">
      <div class="card card-bg shadow rounded-lg border-0 h-100">
        <div class="card-body p-3">
          <div class="d-flex flex-column flex-sm-row justify-content-between h-100">
            <div class="mb-3 mb-sm-0">
              <p class="text-white mb-1 fs-6">Signed</p>
              <p class="mb-0 text-primary-green fs-4">0</p>
            </div>
            <div class="text-center text-sm-end">
              <div class="p-1 p-md-2">
                <i class="fa-solid fa-file-circle-check fa-lg text-primary-green mb-2 mb-md-3"></i>
              </div>
              <a href="#" class="d-block text-primary-green text-decoration-none fs-6 fs-md-5">
                View
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Completed Forms Card -->
    <div class="col">
      <div class="card card-bg shadow rounded-lg border-0 h-100">
        <div class="card-body p-3">
          <div class="d-flex flex-column flex-sm-row justify-content-between h-100">
            <div class="mb-3 mb-sm-0">
              <p class="text-white mb-1 fs-6 fs-md-5">Overdue</p>
              <p class="mb-0 text-primary-green fs-4">0</p>
            </div>
            <div class="text-center text-sm-end">
              <div class="p-1 p-md-2">
                <i class="fa-solid fa-file-shield fa-lg text-primary-green mb-2 mb-md-3"></i>
              </div>
              <a href="#" class="d-block text-primary-green text-decoration-none fs-6 fs-md-5">
                View
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Table Card - Responsive by default -->
  <div class="card border-0 bg-white rounded-lg shadow mt-3 mt-md-4">
    <div class="card-header rounded-lg border-0 bg-white p-3 p-md-4">
      <p class="fs-md-6 mb-0">Contracts</p>
    </div>
    <div class="card-body p-3 p-md-4">
      <div class="table-responsive">
        <GlobalTable
          v-if="contracts.length >0"
          :headers="['No','Contract Name', 'Date sent', 'Due date', 'Status']"
          :data="contracts"
          table_id="invoice">
          <template #actions="{ row }">
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" >
                View
            </button>
          </template>
        </GlobalTable>
        
        <div v-else class="empty-table-message text-center py-5">
          <p class="text-muted mb-0 text-xs">No data available in table</p>
        </div>
      </div>
    </div>
  </div>
  <AICampusFooter/>
</div>